import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.444 15.555 20 12m0 0-3.556-3.556M20 12H7.556m5.333 3.555v.89a2.667 2.667 0 0 1-2.667 2.666H6.667A2.667 2.667 0 0 1 4 16.444V7.555A2.667 2.667 0 0 1 6.667 4.89h3.555a2.667 2.667 0 0 1 2.667 2.666v.89",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render };